<template>
  <div id="About" v-if="page_data != null">
    <parallax-container class="about_scroll_image">
      <parallax-element
        type="translation"
        :parallaxStrength="-20"
        tag="p"
        class="logo"
      >
        {{ page_data[0].title.split(",")[0] }}
        <span>{{ page_data[0].title.split(",")[1] }}</span>
      </parallax-element>

      <parallax-element
        type="translation"
        :parallaxStrength="15"
        tag="img"
        class="bg"
        :src="page_data[0].image"
      />
    </parallax-container>

    <section class="about_company">
      <img
        data-aos="fade-up"
        data-aos-delay="400"
        src="/img/logo.svg"
        class="logo"
      />
      <div
        class="content"
        data-aos="fade-up"
        data-aos-delay="500"
        v-html="page_data[0].content"
      ></div>
    </section>

    <section class="about_middle_part">
      <img src="/img/logo.svg" class="logo" data-aos="rerace" />
      <div
        v-for="line in 20"
        :key="`text_content_line_${line}`"
        class="content"
        data-aos="rerace"
        data-aos-delay="500"
      >
        <div class="text_line" :class="{ even: line % 2 == 0 }">
          <p v-for="item in 10" :key="`text_line_${item}`">
            RERACE PERFORMANCE
          </p>
        </div>
      </div>
      <div class="bg_cover" data-aos="rerace"></div>
    </section>

    <section class="company_info">
      <div class="row">
        <h2 data-aos="fade-up" data-aos-delay="100">
          <b>INFO</b><span>公司資料</span>
        </h2>
        <div class="content">
          <ol>
            <li data-aos="fade-up" data-aos-delay="100">
              <p class="title">公司名稱</p>
              <p class="text_content">
                {{ GetFormData("company_name").title }}
              </p>
            </li>
            <li data-aos="fade-up" data-aos-delay="200">
              <p class="title">設立日期</p>
              <p class="text_content">
                {{ GetFormData("company_create_date").title }}
              </p>
            </li>
            <li data-aos="fade-up" data-aos-delay="300">
              <p class="title">公司登記地址</p>
              <p class="text_content">
                {{ GetFormData("company_address").title }}
              </p>
            </li>
            <li data-aos="fade-up" data-aos-delay="400">
              <p class="title">聯絡電話</p>
              <p class="text_content">
                {{ GetFormData("company_phone").title }}
              </p>
            </li>
          </ol>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import qs from "qs";
import ParallaxContainer from "@/components/MousePrallax/parallax-container";
import ParallaxElement from "@/components/MousePrallax/parallax-element";
export default {
  name: "About",
  components: {
    ParallaxContainer,
    ParallaxElement,
  },
  data() {
    return {
      page_data: null,
      meta_content: "",
    };
  },
  methods: {
    async GetAboutData() {
      let result = await this.SendPostData(
        process.env.VUE_APP_BASE_API + "web_edit/get_common_column.php",
        qs.stringify({
          column_array: [
            "about",
            "company_name",
            "company_address",
            "company_phone",
            "company_email",
            "company_time",
            "company_create_date",
          ],
        })
      );
      if (result != "error") {
        this.page_data = JSON.parse(result.data);
        this.meta_content = this.page_data[0].content.replace(/<[^>]+>/g, "");
        this.$nextTick(() => {
          window.prerenderReady = true;
        });
      }
    },
    GetFormData(key) {
      return this.page_data.filter((item) => item.column_name == key)[0];
    },
  },
  created() {
    this.GetAboutData();
  },

  metaInfo() {
    return {
      title: "關於我們｜銳仕技研｜Rerace Performance",
      meta: [
        {
          property: "og:description",
          content:
            "Rerace 鋭仕技研，起源於2018年。長年專注於開發高品質高性能的避震器內管套件產品，並針對不同需求的玩家進行相對應並且可調的產品開發，希望讓每個喜愛玩車的人都能擁有一支適合自己的避震系統產品研發設計由總經理親自操刀，致力於優化現有避震器構造及材料應用。製造皆由專業技師使用高精密度機器製造，製造過程不放過任何一點小細節。一切都是為了讓喜歡我們的消費者能在購買使用產品後能有物超所值的感受",
          vmid: "og:description",
        },
        {
          property: "twitter:description",
          content:
            "Rerace 鋭仕技研，起源於2018年。長年專注於開發高品質高性能的避震器內管套件產品，並針對不同需求的玩家進行相對應並且可調的產品開發，希望讓每個喜愛玩車的人都能擁有一支適合自己的避震系統產品研發設計由總經理親自操刀，致力於優化現有避震器構造及材料應用。製造皆由專業技師使用高精密度機器製造，製造過程不放過任何一點小細節。一切都是為了讓喜歡我們的消費者能在購買使用產品後能有物超所值的感受",
          vmid: "twitter:description",
        },
        {
          property: "description",
          content:
            "Rerace 鋭仕技研，起源於2018年。長年專注於開發高品質高性能的避震器內管套件產品，並針對不同需求的玩家進行相對應並且可調的產品開發，希望讓每個喜愛玩車的人都能擁有一支適合自己的避震系統產品研發設計由總經理親自操刀，致力於優化現有避震器構造及材料應用。製造皆由專業技師使用高精密度機器製造，製造過程不放過任何一點小細節。一切都是為了讓喜歡我們的消費者能在購買使用產品後能有物超所值的感受",
          vmid: "description",
        },
        {
          property: "og:image",
          content: "https://rerace.yongxin-design.com/img/share/index.jpg",
          vmid: "og:image",
        },
        {
          property: "apple-mobile-web-app-title",
          content: "關於我們｜銳仕技研｜Rerace Performance",
          vmid: "apple-mobile-web-app-title",
        },
        {
          property: "application-name",
          content: "關於我們｜銳仕技研｜Rerace Performance",
          vmid: "application-name",
        },
        {
          property: "og:site_name",
          content: "關於我們｜銳仕技研｜Rerace Performance",
          vmid: "og:site_name",
        },
        {
          property: "og:type",
          content: "website",
          vmid: "og:type",
        },
        {
          property: "og:locale",
          content: "zh_tw",
          vmid: "og:locale",
        },
      ],
    };
  },
};
</script>
